import React, { useState } from "react";
import { Button, EmptyModal, Select } from "../../../../components/core";
import { useQuery } from "@apollo/client";
import { SUPPORT_STATIONS } from "../../../../constants/graphql/locker-clean-up-queries";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { Card } from "primereact/card";

export default function SendPulloutCode({
  open,
  onClose,
  onSendPulloutCode,
  lockerData,
  supportStationId,
  supportStationData,
  setSelectedContact,
  selectedContact,
  totalSelectedPackages = 0,
  sending,
  setIsSending,
}) {
  console.log({ lockerData });
  const [contactList, setContactList] = React.useState([]);
  //   const [selectedContact, setSelectedContact] = React.useState();

  React.useEffect(() => {
    let tempList = [];
    if (lockerData && lockerData.contacts) {
      const clearingContacts = lockerData.contacts.filter(
        (contact) => contact.contactType === "Clearing Contact"
      );

      tempList = clearingContacts.map((contact) => ({
        value: contact.contactMobile,
        name: `${contact.contactMobile} (${contact.contactName})`,
        contactName: contact.contactName,
      }));

      setContactList(tempList);
    }
  }, [lockerData]);

  console.log({ selectedContact, contactList });
  return (
    <>
      {/* <EmptyModal open={open} onClose={onClose} height="50vh" width={"50vw"}>
        <p className="font-bold text-lg text-center">SEND PULL OUT CODE</p>
        <div className="flex">
          <div className="grid grid-cols-2 gap-2 w-full my-auto">
            <p className="my-auto">
              Send <b>Pull Out</b> Code to mobile:
            </p>
            <Select
              className={"w-full"}
              items={[...contactList, ...supportStationData]}
              defaultOption={{
                value: "-1",
                name: "-- Select Clearing Contact Mobile --",
              }}
              onChange={(e) => setSelectedContact(e.target.value)}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <Button value={"Cancel"} className={"p-2"} onClick={onClose} />
          <Button
            value={"Send"}
            className={"p-2"}
            onClick={() => {
              console.log({
                lockerId: lockerData.lockerId,
                newRecipientMobile: selectedContact,
              });
              onSendPulloutCode({
                lockerId: lockerData.lockerId,
                newRecipientMobile: selectedContact,
              });
            }}
          />
        </div>
      </EmptyModal> */}

      <Dialog
        visible={open}
        onHide={onClose}
        draggable={false}
        resizable={false}
        header="Send Pull Out Code"
        className="md:w-[550px] max-w-[95%] "
      >
        <div className="grid grid-cols-9 text-black">
          <div className="col-span-5">Total selected packages:</div>
          <div className="col-span-4 font-bold">
            {totalSelectedPackages} package/s
          </div>

          <div className="col-span-1"></div>
          <Divider className="col-span-7 border border-gray-200" />
          <div className="col-span-1"></div>

          <div className="col-span-9 space-y-2 pb-9">
            <div>
              Send <b>Pullout code</b> to mobile:
            </div>
            <div>
              <Select
                className={"w-full"}
                items={[...contactList, ...supportStationData]}
                defaultOption={{
                  value: "-1",
                  name: "-- Select Clearing Contact Mobile --",
                }}
                onChange={(e) => setSelectedContact(e.target.value)}
              />
            </div>

            {selectedContact && selectedContact !== "-1" && (
              <Card className="col-span-9 border cursor-auto border-primary-primaryYellowLight text-gray-600 ">
                <div className="grid grid-cols-9">
                  <div className="col-span-9 pb-2">
                    Please confirm if the details below are correct. The pullout
                    code(s) will be sent to this mobile number:
                  </div>
                  <div className="col-span-5 italic">
                    Clearing Contact Name:
                  </div>
                  <div className="col-span-4 font-bold italic">
                    {contactList.find(
                      (contact) => contact.value === selectedContact
                    )?.contactName || "N/A"}
                  </div>

                  <div className="col-span-5 italic">
                    Clearing Contact Number:
                  </div>
                  <div className="col-span-4 font-bold italic">
                    {contactList.find(
                      (contact) => contact.value === selectedContact
                    )?.value || "N/A"}
                  </div>
                </div>
              </Card>
            )}
          </div>

          <div className="col-span-9">
            <div className="grid grid-cols-2 gap-2">
              <Button
                value={"Cancel"}
                className={"p-2"}
                onClick={onClose}
                disabled={sending}
              />
              <Button
                value={"Send"}
                className={"p-2"}
                disabled={sending || selectedContact?.length === undefined}
                onClick={() => {
                  console.log({
                    lockerId: lockerData.value,
                    newRecipientMobile: selectedContact,
                  });

                  onSendPulloutCode({
                    lockerId: lockerData.value,
                    newRecipientMobile: selectedContact,
                  });
                }}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
